var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_475_39018)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1369,
    transform: "translate(-1073 -285)",
    fill: "#E37617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-993 -285H367V1084H-993V-285Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_475_39018)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -958,
    y: -157,
    width: 1297,
    height: 1177,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -939.5,
    y: -19.5,
    width: 1261,
    height: 111,
    fill: "white",
    stroke: "#DADADA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_475_39018",
    x: -970,
    y: -161,
    width: 1323,
    height: 1201,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_475_39018"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_475_39018",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_475_39018",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_475_39018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1369,
    fill: "white",
    transform: "translate(-1073 -285)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_475_39018",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.59414772f4caa8e75f87addaa4e901e2.svg";
export { ForwardRef as ReactComponent };